import api from "./api";


export const postLoginEmail = async (body: any) => {
    const response = await api.post(`auth/loginEmail`, body);
    return response.data;
};